import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class TraceabilityService {
    static getTraceability(dto) {
        return lastValueFrom(BaseService.post(`traceability`, dto));
    }
}
